import React from 'react';
import SalesPerformanceContainer from '../../containers/salesPerformance/SalesPerformanceContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const SalesPerformancePage = () => {
  return (
    <>
      <BreadcrumbsContainer title="영업활동관리/휴일관리" icon="partner" />
      <SalesPerformanceContainer />
    </>
  );
};

export default SalesPerformancePage;
